<script>
import { mapState, mapActions } from 'vuex';
import validatorMixin from '../../mixins/validatorMixin';

export default {
  name: 'FerryExtraEdit',
  mixins: [validatorMixin],
  props: {
    shown: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      validForm: true,
      current: null,
    };
  },
  computed: {
    ...mapState({
      extra: state => state.transportation.extras.extra,
      saveError: state => state.transportation.extras.saveError,
      saveLoading: state => state.transportation.extras.saveLoading,
    }),
    changesMade() {
      const changes = JSON.stringify(this.current) !== JSON.stringify(this.extra);
      this.$emit('input', changes);
      return changes;
    },
  },
  methods: {
    ...mapActions({
      updateExtra: 'transportation/updateExtra',
    }),
    saveEditExtra() {
      if (this.validForm && this.changesMade) {
        const body = {
          ...this.current,
          dateFrom: this.current.dateFrom ? this.$moment(this.current.dateFrom, 'DD/MM/YY').format('YYYY-MM-DD') : null,
          dateTo: this.current.dateTo ? this.$moment(this.current.dateTo, 'DD/MM/YY').format('YYYY-MM-DD') : null,
        };
        this.updateExtra(body)
          .then((res) => {
            if (res) {
              this.$emit('close', true);
            }
          });
      }
    },
  },
  watch: {
    shown() {
      if (this.shown) {
        this.current = {
          ...this.extra,
          dateFrom: this.extra.dateFrom ? this.$moment(this.extra.dateFrom).format('DD/MM/YY') : null,
          dateTo: this.extra.dateTo ? this.$moment(this.extra.dateTo).format('DD/MM/YY') : null,
        };
        this.$emit('input', this.changesMade);
      }
    },
  },
};
</script>

<template>
  <v-card v-if="extra && current">
    <v-form v-model="validForm" @submit.prevent="saveEditExtra">
      <v-card-title>
        <span class="headline">
          Edit Extra
        </span>
      </v-card-title>

      <v-card-text class="py-0 mb-3 edit-item-status">
        <v-progress-linear
          v-if="saveLoading"
          :active="saveLoading"
          :height="4"
          class="my-0"
          indeterminate
        />
        <v-alert
          v-if="!saveLoading"
          :value="!!saveError"
          class="my-0 py-2"
          transition="slide-y-transition"
          outline
        >
          An error occurred while saving
        </v-alert>
      </v-card-text>

      <v-card-text class="py-0">
        <v-container grid-list-md pt-1>
          <v-layout row>
            <v-flex xs12>
              <v-text-field
                v-model="current.name"
                :rules="[rules.required]"
                :disabled="saveLoading"
                label="Name"
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-text-field
                v-model="current.webName"
                :rules="[rules.required]"
                :disabled="saveLoading"
                label="Name displayed on the website"
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-text-field
                v-model="current.externalRef"
                :rules="[rules.required]"
                :disabled="saveLoading"
                hint="External ref is used to identify the extra against suppliers system"
                label="External reference"
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-checkbox
                v-model="current.active"
                :disabled="saveLoading"
                label="Active"
                class="mt-0"
                hide-details
              />
            </v-flex>
          </v-layout>

          <v-divider class="my-3"></v-divider>

          <v-layout row>
            <v-flex xs12>
              <h3>Optional</h3>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs6>
              <v-text-field
                v-model="current.dateFrom"
                :disabled="saveLoading"
                hint="dd/mm/yy"
                mask="##/##/##"
                label="Date From"
                return-masked-value
              />
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-model="current.dateTo"
                :disabled="saveLoading"
                hint="dd/mm/yy"
                mask="##/##/##"
                label="Date To"
                return-masked-value
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs6>
              <v-text-field
                v-model="current.timeFrom"
                :disabled="saveLoading"
                hint="hh:mm"
                mask="##:##"
                label="Time From"
                return-masked-value
              />
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-model="current.timeTo"
                :disabled="saveLoading"
                hint="hh:mm"
                mask="##:##"
                label="Time To"
                return-masked-value
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn
          @click="$emit('close')"
          color="red darken-1"
          flat
        >
          Close
        </v-btn>
        <v-tooltip :disabled="changesMade" top>
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-btn
                :disabled="!validForm || saveLoading || !changesMade"
                color="blue darken-1"
                type="submit"
                flat
              >
                Save
              </v-btn>
            </div>
          </template>
          <span>
            No changes has been made
          </span>
        </v-tooltip>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<style lang="scss">
  .edit-item-status {
    min-height: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/transportation/TransportationExtraEdit.vue